













import { Component, Prop } from 'vue-property-decorator'
import { BaseInput, ICampoTemplate } from './base/BaseInput'

@Component({
  name: 'InputDate'
})
export default class InputDate extends BaseInput {
  @Prop({ required: true })
  campo!: ICampoTemplate
}
